import React, { useState } from "react";
import {
  Dimmer,
  Loader,
  Grid,
  Segment,
  Form,
  Button,
  Message
} from "semantic-ui-react";
import { useGetMeQuery, useLoginMutation } from "../features/api/apiSlice";

// Gates the whole app behind a login form that authenticates against the same
// .htpasswd users the site used to require via nginx basic auth. While the
// session check is in flight we show a loader; once authenticated the wrapped
// app is rendered.
function LoginForm() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [login, { isLoading }] = useLoginMutation();
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await login({ username: username.trim(), password }).unwrap();
      // Reload so the live socket re-handshakes carrying the new session cookie
      // (it was created at page load, before login, so the backend couldn't yet
      // associate it with this user for bell notifications). The reload also
      // refreshes getMe and renders the app.
      window.location.reload();
    } catch (err) {
      const msg =
        (err && err.data && err.data.message) ||
        "Invalid username or password";
      setError(msg);
    }
  };

  return (
    <Grid textAlign="center" style={{ height: "100vh" }} verticalAlign="middle">
      <Grid.Column style={{ maxWidth: 400 }}>
        <Form size="large" onSubmit={submit} error={!!error}>
          <Segment stacked>
            <Form.Input
              fluid
              icon="user"
              iconPosition="left"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
            />
            <Form.Input
              fluid
              icon="lock"
              iconPosition="left"
              placeholder="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Message error content={error} />
            <Button
              primary
              fluid
              size="large"
              type="submit"
              loading={isLoading}
              disabled={isLoading || !username || !password}
            >
              Log in
            </Button>
          </Segment>
        </Form>
      </Grid.Column>
    </Grid>
  );
}

export default function LoginGate({ children }) {
  const { data, isLoading, isFetching } = useGetMeQuery();

  if (isLoading || isFetching) {
    return (
      <Dimmer active inverted>
        <Loader>Loading…</Loader>
      </Dimmer>
    );
  }

  if (!data || !data.user) {
    return <LoginForm />;
  }

  return children;
}
